<app-main-page>
  <app-services-list></app-services-list>
</app-main-page>
